<div class="flex items-center justify-between">
  <div class="typo-h4-light text-text-tertiary">{{ 'schedule_details_appointment_date' | translate }}</div>
  <div class="flex h-10 w-[250px] items-center justify-start px-3">
    <button (click)="datePicker.clickCalendarButton()" class="typo-h4-medium">
      {{ appointmentDateFormattedSignal() }}
    </button>
    <lib-date-picker
      #datePicker
      class="pointer-events-none absolute opacity-0"
      [date]="appointmentDateSignal()"
      (dateChange)="onDateSelect($event)"
    />
  </div>
</div>
<div class="flex items-center justify-between">
  <div class="typo-h4-light text-text-tertiary">{{ 'schedule_details_appointment_time' | translate }}</div>
  <div class="flex w-[250px] items-center gap-3">
    <lib-dropdown
      #startTimeDropdown
      class="w-[100px] whitespace-nowrap rounded-2xl border"
      [ngClass]="{
        'border-primary-blue': startTimeDropdown.dropdownOpen(),
        'border-states-white': !startTimeDropdown.dropdownOpen()
      }"
      [overlayMaxHeight]="timeOverlayHeight"
      [overlayWidth]="timeOverlayWidth"
      [overlayPositionStrategy]="overlayPositionStrategyFrom"
      [showDropdownIcon]="false"
      [options]="startTimeStamps"
      [value]="startTimeSignal()"
      (valueChange)="onStartTimeSelect($event)"
      [hasMinWidth]="false"
      [border]="false"
    />
    <span class="text-center text-text-tertiary">
      {{ 'schedule_details_appointment_to' | translate }}
    </span>
    <lib-dropdown
      #endTimeDropdown
      class="w-[100px] whitespace-nowrap rounded-2xl border"
      [ngClass]="{
        'border-primary-blue': endTimeDropdown.dropdownOpen(),
        'border-states-white': !endTimeDropdown.dropdownOpen()
      }"
      [overlayMaxHeight]="timeOverlayHeight"
      [overlayWidth]="timeOverlayWidth"
      [overlayPositionStrategy]="overlayPositionStrategyTo"
      [showDropdownIcon]="false"
      [options]="endTimeStamps"
      [value]="endTimeSignal()"
      (valueChange)="onEndTimeSelect($event)"
      [hasMinWidth]="false"
      [border]="false"
    />
  </div>
</div>
